export const ContractImage = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="9" y="1" width="78" height="94" stroke="#0A1D34" strokeWidth="2" />
    <path d="M24 80H56" stroke="#0A1D34" strokeWidth="2" />
    <path d="M24 16H72" stroke="#0A1D34" strokeWidth="2" />
    <path d="M24 24H72" stroke="#0A1D34" strokeWidth="2" />
    <path d="M24 32H72" stroke="#0A1D34" strokeWidth="2" />
    <path d="M24 40H72" stroke="#0A1D34" strokeWidth="2" />
    <path d="M24 68L30 74M30 68L24 74" stroke="#0A1D34" strokeWidth="2" />
  </svg>
);
